import React from 'react';
import { Badge } from 'react-bootstrap';
import './tableBilling.scss';

const GenericTable = ({ data, columns, footerText }) => {
	const formatCell = (col, row) => {
		if (col.render) return col.render(row[col.dataIndex], row);
		return row[col.dataIndex];
	};

	return (
		<div className="table-billing-grid">
			{/* Header */}
			<div className="table-header">
				{columns.map((col) => (
					<div key={col.title} className="header-cell">
						{col.title}
					</div>
				))}
			</div>

			{/* Data Rows */}
			{data?.map((row, index) => (
				<div key={row.grantId || index} className="table-row">
					{columns.map((col) => (
						<div key={col.title} className="data-cell">
							{formatCell(col, row)}
						</div>
					))}
				</div>
			))}

			{/* Footer */}
			{footerText && (
				<div className="table-footer">
					<div className="footer-text">
						{footerText}
					</div>
				</div>
			)}
		</div>
	);
};

export default GenericTable;